import { Clear } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import { useYaMetrika } from '@/entities/yaMetrika';
import { viewSettingsStore } from '@/features/viewSettings';
import { AnalyticsEvent } from '@/types/yametrika';
import { formatDurationRussian } from '@/utils/formatDurationRussian';
import { parseTimeExpression, parseTimeInput } from '@/utils/parseTimeInput';

import { TimeButton, times } from '../TimeButton';

import { clearButtonSx } from './styles';

import s from './TimeButtonsSection.module.scss';

type TimeButtonsSectionProps = {
  currentValue: string;
  onChange: (value: string) => void;
  className?: string;
  /** "add" — adds clicked time to current value; "set" — replaces current value. If not passed, uses global setting */
  mode?: 'add' | 'set';
};

export const TimeButtonsSection: React.FC<TimeButtonsSectionProps> = observer(
  ({ currentValue, onChange, className, mode: modeProp }) => {
    const { sendEvent } = useYaMetrika();
    const { addTimeWithQuickButtons } = viewSettingsStore;
    const mode = modeProp ?? (addTimeWithQuickButtons ? 'add' : 'set');

    const handleTimeClick = (time: string) => {
      const timeMinutes = parseTimeInput(time) || 0;

      const totalMinutes =
        mode === 'set' ? timeMinutes : (parseTimeExpression(currentValue) || 0) + timeMinutes;

      const formatted = formatDurationRussian(totalMinutes);

      onChange(formatted);
      sendEvent(AnalyticsEvent.useQuickInputButtons);
    };

    const handleClear = () => {
      onChange('');
    };

    return (
      <div className={clsx(s.time_buttons_wrapper, className)}>
        <Box className={clsx(s.time_buttons)}>
          <Button onClick={handleClear} variant="contained" sx={clearButtonSx}>
            <Clear fontSize="small" />
          </Button>
          {times.map((time) => (
            <TimeButton time={time} key={time} onClick={() => handleTimeClick(time)} />
          ))}
        </Box>
      </div>
    );
  },
);
